import React from "react";
import "./NeonHeading.css";

/**
 * NeonHeading Component
 * Renkli ve neon ışık efektli başlık componenti
 * 
 * color değerleri: "red", "purple", "blue", "green", "orange", "pink", "cyan"
 */
const NeonHeading = ({ children, color = "cyan", tag = "h2", className = "", style = {} }) => {
    const Tag = tag;

    return (
        <div className="neon-heading-wrapper">
            <Tag
                className={`neon-heading neon-${color} ${className}`}
                style={style}
            >
                {children}
            </Tag>
        </div>
    );
};

export default NeonHeading;
